export const targetDropdownOptions = [
  { dsId: 'id1', label: 'Target Price', type: 'single' },
  { dsId: 'id2', label: 'Target Rate', type: 'single' },
];

export const rowNumberDropdownOptions = [
  { dsId: 'five', label: '5', type: 'single' },
  { dsId: 'all', label: 'ALL', type: 'single' },
];

export const defaultRowNumberDropdownOption = {
  dsId: 'five',
  label: '5',
  type: 'single',
};

export const targetRateOptions = (
  label: string,
  isZeroBasedPricing: boolean,
) => ({
  prefix: '',
  integerLimit: 3,
  decimalLimit: 3,
  allowDecimal: true,
  suffix: label === 'Target Rate' ? '%' : '',
  allowNegative: label === 'Target Price' && isZeroBasedPricing,
});

export const getTargetValue = (
  value: number,
  selectedTargetLabel: { dsId: string; label: string; type: string },
) => {
  let parseValue = String(!Number.isInteger(value) ? value.toFixed(3) : value);
  if (selectedTargetLabel.label === 'Target Rate' && value >= 0 && value <= 20)
    parseValue += '%';
  return parseValue;
};

export const getTargetLabel = (target, isZeroBasedPricing, targetLabel) => {
  const { 0: targetPrice, 1: targetRate } = targetDropdownOptions;
  if (targetLabel === 'Rate') return { ...targetRate };
  let label = { ...targetPrice };
  if (!isZeroBasedPricing && target >= 0 && target <= 20)
    label = { ...targetRate };
  return label;
};
